// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2tej1","alertIcon":"ConfirmModal_alertIcon__2EEFY"};